export default __webpack_public_path__ + "static/media/node.6ec58641.png";